// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"4fc4a2fe","236":"da9ee4f9","688":"55ce137d","863":"dccf5575"}[chunkId] + ".chunk.css";
};